import React, { useState } from 'react';
import { Popover, Button } from 'antd';
import TrainerActLogModal from './trainer_actlog_modal';
import DeleteBox from './delete_box';
import { restApi } from '../../../apis';

function TitleComponent(props) {
  return (
    <div
      style={{
        display: 'flex',
        height: '4.2rem',
        justifyContetn: 'center',
        alignItems: 'center',
        background: '#7367F0',
        borderRadius: '10px 10px 0px 0px',
        paddingLeft: 20,
        color: '#FFF',
      }}
    >{`트레이너당 메뉴`}</div>
  );
}
//----------------------------------------------------------------------------------------------------
function ContentComponent(props) {
  const {
    gModal,
    setGModal,
    uuid,
    accountId,
    adminName = 'Empty', // === trainerName
    // trainerName = 'Empty',
    setPopup,
    messageApi,
    setSorts,
    isValid,
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          marginTop: '-0.7rem',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            // Route.Link('/');
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <TrainerActLogModal trainerName={adminName} {...props} />
                ),
              };
            });
            setPopup(false);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            {`활동 로그 데이터 보기`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            // Route.Link('/');
            // messageApi?.error(
            //   `[준비중]활동정지 관련 정책이 정리되지 않았습니다.`
            // );
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <div style={{ backgroundColor: '#FFF' }}>
                    <DeleteBox
                      id={accountId}
                      title={
                        isValid == 'T'
                          ? `${adminName} 트레이너 계정 정지`
                          : `${adminName}  트레이너 계정 활성`
                      }
                      boxTitle={
                        isValid == 'T'
                          ? `해당 트레이너 계정을 정지하시겠습니까?`
                          : `해당 트레이너 계정을 활성하시겠습니까?`
                      }
                      boxContents={``}
                      buttonTitle={isValid == 'T' ? `활동정지` : '활성'}
                      onClosed={() => {
                        // 팝업닫기
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            };
                          });
                        }, 500);
                      }}
                      onDeleted={async () => {
                        const response = await restApi
                          .patch(
                            `/admin/trainer/${accountId}?isValid=${
                              isValid == 'T' ? 'false' : 'true'
                            }`,
                            {}
                          )
                          .then((v) => {
                            return v?.data;
                          });

                        if (response && response.message) {
                          messageApi.info(response.message);
                        } else {
                          messageApi.info(
                            isValid == 'T'
                              ? '활동 정지에 실패하였습니다.'
                              : '활동에 실패하였습니다.'
                          );
                        }

                        // 팝업닫기
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            };
                          });
                        }, 1000);

                        // 화면갱신
                        setSorts((prev) => {
                          return {
                            ...prev,
                            refresh: new Date(),
                          };
                        });
                      }}
                    />
                  </div>
                ),
              };
            });
            setPopup(false);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            {isValid == 'T' ? `활동 정지 시키기` : `활동 승인 하기`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            // Route.Link('/');
            // messageApi?.error(
            //   `삭제후 관련 정보는 복구할 수 없습니다. 상세정보에서 확인후 삭제해 주시기 바랍니다.`
            // );
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <div style={{ backgroundColor: '#FFF' }}>
                    <DeleteBox
                      id={accountId}
                      title={`트레이너 계정 삭제`}
                      boxTitle={`해당 트레이너 계정을 삭제하시겠습니까?`}
                      boxContents={`삭제한 계정에 포함된 데이터(시퀀스/템포/강의)는 밸런스피터 DB로 종속되며, 한번 삭제한 트레이너 계정은 다시 복구할 수 업습니다. 정말 삭제하시겠습니까?`}
                      buttonTitle={`트레이너 계정 삭제`}
                      onClosed={() => {
                        // 팝업닫기
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            };
                          });
                        }, 500);
                      }}
                      onDeleted={async () => {
                        const response = await restApi
                          .delete(`/admin/trainer/${accountId}`, {
                            params: { depth: null },
                          })
                          .then((v) => {
                            return v && v.data && v.data.payload;
                          });

                        messageApi.info(
                          (response && response.message) ||
                            '삭제하는데 실패하였습니다.'
                        );

                        // 팝업닫기
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            };
                          });
                        }, 1000);

                        // 화면갱신
                        setSorts((prev) => {
                          return {
                            ...prev,
                            refresh: new Date(),
                          };
                        });
                      }}
                    />
                  </div>
                ),
              };
            });
            setPopup(false);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
              color: '#DB4437',
            }}
          >
            {`트레이너 삭제하기`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
    </div>
  );
}
//----------------------------------------------------------------------------------------------------

const TrainerPopover = (props) => {
  const component = props.component;
  const width = props.width;
  const [clicked, setPopup] = useState(false);
  return (
    <Popover
      placement="leftTop"
      title={TitleComponent({ ...props })}
      content={ContentComponent({ ...props, setPopup })}
      overlayStyle={{ width: 240 }}
      overlayInnerStyle={{ padding: 0 }}
      showArrow={false}
      trigger="click" // focus  hover  click
      open={clicked}
      onOpenChange={(open) => {
        setPopup(open);
      }}
    >
      <Button
        type="link"
        style={{
          display: 'flex',
          width,
          flexDirection: 'column',
          justifyContetn: 'center',
          alignItems: 'center',
        }}
      >
        {component}
      </Button>
    </Popover>
  );
};

export default TrainerPopover;
